<template>
    <div class="ma-6">
      <div v-if="suppliercari.length===0">Tidak ditemukan penjual dengan kata kunci <b>{{cari.cari}}</b></div>
      <v-layout row wrap class="mt-2">
        <v-flex lg2  sm6 xs12 v-for="(item, index) in suppliercari"  :key="index">
          <v-card class="ma-4" elevation="1">
            <div :class="item.status===1?'box2':'box1'"><h5>{{tokostatustext(item.status)}}</h5></div>
            <v-card-text class="align-center align-content-center">
              <v-img v-if="item.avatar" width="100px" height="100px" :src="item.avatar"></v-img>
              <v-img width="100px" height="100px" v-else src="https://res.cloudinary.com/dd5jfnv3x/image/upload/v1519482855/default-image.png"></v-img>
              <div class="ma-1">{{potongnama(item.sellername)}}</div>
              <v-row
                  class="ml-1"
              >
                <v-rating :value="item.rating" color="amber" dense readonly size="14"></v-rating>
                <div class="grey--text ml-4">
                  {{item.rating}} ({{item.jmlreview}})
                </div>
              </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
<!--              <v-icon>label</v-icon> 124-->
              <v-spacer></v-spacer>
              <v-btn @click="gosellerpage(item.sellerid)" text>Lihat</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import S from 'string'

export default {
  name: 'CariSuplier',
  data: () => ({

  }),
  computed: {
    ...mapState('ProductStore', ['suppliercari']),
    cari () {
      return this.$route.query
    }
  },
  methods: {
    ...mapActions('ProductStore', []),
    gosellerpage (id) {
      this.$router.push('/supplier/' + id)
    },
    tokostatustext (val) {
      if (val === 1) {
        return 'Buka'
      } else {
        return 'Tutup'
      }
    },
    potongnama (val) {
      if (val.length > 20) {
        return S(val).left(20).replaceAll('`', '').s
      } else {
        return val.toUpperCase()
      }
    }
  }
}
</script>

<style scoped>

.label-buka {
  float: right;
  position: relative;
  right: 12px;
  top: 190px;
}
.box2 {
  position: relative;
  z-index: 1;
  width: 50px;
  float: left;
  padding: 5px 20px;
  margin: 0 auto;
  background: scroll;
  border-radius: 4px;
}
.box2 h5 {
  position:relative;
  padding:0 2px;
  margin:0 -30px 1px;
  font-size:16px;
  line-height:32px;
  font-weight:bold;
  text-align:center;
  color:#fff;
  background:#079c07;
  text-shadow:0 1px 1px rgba(0,0,0,0.2);
  -webkit-box-shadow:0 1px 1px rgba(0,0,0,0.2);
  -moz-box-shadow:0 1px 1px rgba(0,0,0,0.2);
  box-shadow:0 1px 1px rgba(0,0,0,0.2);
  zoom:1;
}
.box2 h5:before,
.box2 h5:after {
  content:"";
  position:absolute;
  z-index:-1;
  top:100%;
  left:0;
  border-width:0 10px 10px 0;
  border-style:solid;
  border-color:transparent darkgreen;
}

.box1 {
  position: relative;
  z-index: 1;
  width: 50px;
  float: left;
  padding: 5px 20px;
  margin: 0 auto;
  background: scroll;
  border-radius: 4px;
}
.box1 h5 {
  position:relative;
  padding:0 2px;
  margin:0 -30px 1px;
  font-size:16px;
  line-height:32px;
  font-weight:bold;
  text-align:center;
  color:#fff;
  background:#cc0000;
  text-shadow:0 1px 1px rgba(0,0,0,0.2);
  -webkit-box-shadow:0 1px 1px rgba(0,0,0,0.2);
  -moz-box-shadow:0 1px 1px rgba(0,0,0,0.2);
  box-shadow:0 1px 1px rgba(0,0,0,0.2);
  zoom:1;
}

.box1 h5:before,
.box1 h5:after {
  content:"";
  position:absolute;
  z-index:-1;
  top:100%;
  left:0;
  border-width:0 10px 10px 0;
  border-style:solid;
  border-color:transparent maroon;
}

</style>
